<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"> </p>
<p class="chapsoy-title">UX/UI Designers are professionals who design how an app or software looks. They make mockups and wireframes (sketch drawings) to help software engineers design an app. They also get feedback from users to see how people are using their app (very psychology-based). The post above shows a salary range of $70k- $110k; this is a common range for experienced UX/UI professionals. Best of all, no degree needed. The best way to get your foot in the door as a UX/UI designer is to take a bootcamp at a coding school.</p>
<div class="calibre1" id="calibre_pb_12"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_012.vue?480f0958